<template>
  <v-container fill-height fluid>
    <v-layout justify-center wrap>
      <v-flex xs12 md6>
        <material-card class="v-card-profile">
          <v-avatar
            slot="offset"
            class="mx-auto d-block"
            size="130">
            <v-icon size="50" color="orange">mdi-book-open</v-icon>
          </v-avatar>
          <v-card-text class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.RecordBooks.model.record_book_type')}}</label>
                  <p>{{recordBook && recordBook.partner ? recordBook.recordBookType.name : ''}}</p>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.RecordBooks.model.number')}}</label>
                  <p>{{recordBook.number}}</p>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.RecordBooks.model.partner')}}</label>
                  <p>{{recordBook && recordBook.partner ? recordBook.partner.name : ''}}</p>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.RecordBooks.model.document_type')}}</label>
                  <p>{{recordBook && recordBook.partner ? recordBook.documentType.name : ''}}</p>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.RecordBooks.model.import_transport_type')}}</label>
                  <p>{{recordBook && recordBook.partner ? recordBook.importTransportType.name : ''}}</p>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.RecordBooks.model.export_transport_type')}}</label>
                  <p>{{recordBook && recordBook.partner ? recordBook.exportTransportType.name : ''}}</p>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.RecordBooks.model.real_location')}}</label>
                  <p>{{recordBook && recordBook.partner ? recordBook.realLocation.name : ''}}</p>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.RecordBooks.model.value')}}</label>
                  <p>{{recordBook.value ? recordBook.value : $t('Common.not_assigned')}}</p>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.RecordBooks.model.files')}}</label>
                  <template v-for="(file, index) in recordBook.recordBookFiles">
                    <v-tooltip top :key="index">
                      <a slot="activator" :href="$http.defaults.storageURL + file.url" :download="file.url" target="_blank" class="indigo--text">
                        <template v-if="file.url.split('.')[1] === 'pdf'">
                          <v-icon color="indigo" large>mdi-file-pdf-box</v-icon>
                        </template>
                        <template v-else-if="file.url.split('.')[1] === 'docx'">
                          <v-icon color="indigo" large>mdi-file-word-box</v-icon>
                        </template>
                        <template v-else-if="file.url.split('.')[1] === 'xlsx'">
                          <v-icon color="indigo" large>mdi-file-excel-box</v-icon>
                        </template>
                        <template v-else>
                          <v-icon color="indigo" large>mdi-image</v-icon>
                        </template>
                        <br>
                        <span>{{file.url.split('.')[0]}}</span>
                      </a>
                      <span>{{ $t('Pages.RecordBooks.download_file') }}</span>
                    </v-tooltip>
                  </template>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-btn color="warning" round class="font-weight-light" :to="'/record-books/' + recordBook.id + '/update'">{{$t('Core.Fields.edit')}}</v-btn>
            <v-btn round class="font-weight-light" href="javascript:history.go(-1)">{{$t('Core.Fields.back')}}</v-btn>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import _ from 'lodash';
  export default {
    components: {},
    data: () => ({
        recordBook: {},
    }),
    computed: {

    },
    created () {
      this.getRecordBook(this.$route.params.id);
    },
    methods: {
      getRecordBook(id){
        this.setFetching(true);
        this.repositories.recordBook.get(id, 'partner,importTransportType,exportTransportType,recordBookFiles,recordBookType,documentType,realLocation,user').then(response => {
          this.recordBook = response.data.data;
        }).finally(() => {
          this.setFetching(false);
        });
      }
    }
  }
</script>
